import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoggerService } from '@itavan/lib/core/services';
import { SupabaseSession } from '@itavan/lib/core/supabase';
import { firstValueFrom } from 'rxjs';

export const authGuard = async () => {
  const authService = inject(SupabaseSession);
  const router = inject(Router);
  const logger = inject(LoggerService);

  // ⭐ firstValueFrom ahora solo espera hasta que ready=true
  const session = await firstValueFrom(authService.session$);
  logger.log('authGuard', session);

  if (session?.user) {
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
};
